import { differenceInMinutes } from "date-fns";

/**
 * Checks if a user is online based on the last seen timestamp and a threshold.
 *
 * @param lastSeenTimestamp - The timestamp of the user's last activity.
 * @param thresholdInMinutes - The threshold in minutes to consider the user online. Default is 5 minutes.
 * @returns `true` if the user is online, `false` otherwise.
 */

export const isSenderUserOnline = (
  lastSeenTimestamp: number | null | undefined,
  thresholdInMinutes: number = 5
): boolean => {
  if (!lastSeenTimestamp) {
    return false;
  }

  const lastSeenDate = new Date(lastSeenTimestamp);
  const currentDate = new Date();

  return differenceInMinutes(currentDate, lastSeenDate) <= thresholdInMinutes;
};
